<div class="home-slides" *ngIf="sliders">
    <owl-carousel-o [options]="homeSlides">
        <ng-template carouselSlide *ngFor="let slide of sliders">
            <div class="main-banner" style="background-image: url({{imageUrl}}{{slide.image}})">
                <div class="d-table">
                    <div class="d-table-cell">
                        <div class="container">
                            <div class="main-banner-content">
                                <span class="sub-title"></span>
                                <div style="background-color: #0067A5;  opacity: 0.8; padding: 5px">
                                    <h1>{{slide.title}}</h1>
                                    <p>{{slide.text}}</p>
                                </div>
                                <div class="btn-box">
                                    <a routerLink="/contact" class="default-btn"><i class='bx bx-move-horizontal icon-arrow before'></i><span class="label">{{slide.button_text}}</span><i class="bx bx-move-horizontal icon-arrow after"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>

    </owl-carousel-o>
</div>
